"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBusinessesInternalResponseToJSON = exports.GetBusinessesInternalResponseFromJSONTyped = exports.GetBusinessesInternalResponseFromJSON = exports.instanceOfGetBusinessesInternalResponse = void 0;
var runtime_1 = require("../runtime");
var BusinessResponse_1 = require("./BusinessResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the GetBusinessesInternalResponse interface.
 */
function instanceOfGetBusinessesInternalResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetBusinessesInternalResponse = instanceOfGetBusinessesInternalResponse;
function GetBusinessesInternalResponseFromJSON(json) {
    return GetBusinessesInternalResponseFromJSONTyped(json, false);
}
exports.GetBusinessesInternalResponseFromJSON = GetBusinessesInternalResponseFromJSON;
function GetBusinessesInternalResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'businesses': !(0, runtime_1.exists)(json, 'businesses') ? undefined : (json['businesses'].map(BusinessResponse_1.BusinessResponseFromJSON)),
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
    };
}
exports.GetBusinessesInternalResponseFromJSONTyped = GetBusinessesInternalResponseFromJSONTyped;
function GetBusinessesInternalResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'businesses': value.businesses === undefined ? undefined : (value.businesses.map(BusinessResponse_1.BusinessResponseToJSON)),
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
    };
}
exports.GetBusinessesInternalResponseToJSON = GetBusinessesInternalResponseToJSON;
